import axios from 'axios';

const caseBaseUrl = '/api/cases';

export const getCaseRegistryVariant = async (caseUuid: string, caseInPreview: boolean): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/case-registry-variant?caseInPreview=${caseInPreview}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCaseCaseRegistry = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/case-registry`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};
